import { z } from "zod";
import { birthDataSchema } from "./birth";
import { flag, int, lenientArray, real, text } from "./common";

export const placementSchema = z.object({
  planet: text("Unknown"),
  sign: text("Unknown"),
  house: int(),
  nakshatra: text("—"),
  pada: int(),
  longitude: real(),
  retrograde: flag(),
});
export type Placement = Readonly<z.output<typeof placementSchema>>;

/** The rasi (D1) chart as the engine computed it. */
export const chartSchema = z.object({
  ascendant_sign: text("Unknown"),
  ascendant_longitude: real(),
  placements: lenientArray(placementSchema),
  engine_version: text("unknown"),
  computed_for_utc: text(),
});
export type Chart = Readonly<z.output<typeof chartSchema>>;

/** `GET /me/profile`: the person's own birth profile and chart. */
export const userProfileSchema = z.object({
  profile_id: text(),
  birth: birthDataSchema.nullish().catch(undefined),
  chart: chartSchema,
});
export type UserProfile = Readonly<z.output<typeof userProfileSchema>>;

/** Envelope of `POST /chart/preview` and `POST /birth-profiles`. */
export const chartEnvelopeSchema = z.object({
  profile_id: text(),
  chart: chartSchema,
});

export const vargaPlacementSchema = z.object({
  planet: text(),
  varga_sign: text(),
  rasi_sign: text(),
  house: int(1),
  retrograde: flag(),
});
export type VargaPlacement = Readonly<z.output<typeof vargaPlacementSchema>>;

/** One divisional chart, `GET /me/varga?divisor=N`. */
export const vargaChartSchema = z.object({
  divisor: int(1),
  name: text(),
  signification: text(),
  ascendant_sign: text(),
  placements: lenientArray(vargaPlacementSchema),
});
export type VargaChart = Readonly<z.output<typeof vargaChartSchema>>;

/** One entry of the divisional-chart menu, `GET /me/charts`. */
export const chartSummarySchema = z.object({
  divisor: int(1),
  name: text(),
  read_for: text(),
});
export type ChartSummary = Readonly<z.output<typeof chartSummarySchema>>;

export const chartMenuSchema = z.object({
  charts: lenientArray(chartSummarySchema),
});
